import { companyLogoImageConfig } from '@/lib/files/images';
import { getOriginalImageDimensions } from '@/utils/getOriginalImageDimensions';

export async function getResizedCompanyLogoDimensions(
    file: File,
    setError: (...args: any[]) => void
) {
    try {
        let originalDimensions = {
            width: companyLogoImageConfig.minWidth,
            height: companyLogoImageConfig.minHeight
        };
        const dimensions = await getOriginalImageDimensions(URL.createObjectURL(file));
        if (dimensions.width && dimensions.height) {
            originalDimensions = dimensions;
        }
        const resizedDimensions = {
            width: originalDimensions.width,
            height: originalDimensions.height
        };
        if (originalDimensions.width > originalDimensions.height) {
            resizedDimensions.width = companyLogoImageConfig.minWidth;
            resizedDimensions.height = Math.round(
                originalDimensions.height /
                    (originalDimensions.width / companyLogoImageConfig.minWidth)
            );
        } else {
            resizedDimensions.width = Math.round(
                originalDimensions.width /
                    (originalDimensions.height / companyLogoImageConfig.minHeight)
            );
            resizedDimensions.height = companyLogoImageConfig.minHeight;
        }

        return resizedDimensions;
    } catch (e) {
        setError(e);
    }
}
